export function indicateExit() {

    /*
    return `if (!self._activeHandles || self._activeHandles.size === 0) {
        postMessage([{op: 20}]); // Send exit event only if no active handles
    }`;
    */
    return ""
}